/**
 * SmartdineNow API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent } from '@angular/common/http';
import { CustomHttpUrlEncodingCodec } from '../encoder';

import { Observable } from 'rxjs';

import { SmartDineResponseUserGroupMapEntity } from '../model/smartDineResponseUserGroupMapEntity';
import { UserGroupMapEntity } from '../model/userGroupMapEntity';

import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';


@Injectable()
export class UserGroupMapRestControllerService {

    protected basePath = 'http://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createUserUserGroupMapMaps(body: UserGroupMapEntity, observe?: 'body', reportProgress?: boolean): Observable<SmartDineResponseUserGroupMapEntity>;
    public createUserUserGroupMapMaps(body: UserGroupMapEntity, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmartDineResponseUserGroupMapEntity>>;
    public createUserUserGroupMapMaps(body: UserGroupMapEntity, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmartDineResponseUserGroupMapEntity>>;
    public createUserUserGroupMapMaps(body: UserGroupMapEntity, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling createUserUserGroupMapMaps.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<SmartDineResponseUserGroupMapEntity>('post',`${this.basePath}/api/admin/usergroupmaps`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param userGroupMapId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteUserGroupMap(userGroupMapId: string, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public deleteUserGroupMap(userGroupMapId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public deleteUserGroupMap(userGroupMapId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public deleteUserGroupMap(userGroupMapId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (userGroupMapId === null || userGroupMapId === undefined) {
            throw new Error('Required parameter userGroupMapId was null or undefined when calling deleteUserGroupMap.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<string>('delete',`${this.basePath}/api/admin/usergroupmaps/${encodeURIComponent(String(userGroupMapId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param userGroupMapId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getUserGroupMap(userGroupMapId: string, observe?: 'body', reportProgress?: boolean): Observable<SmartDineResponseUserGroupMapEntity>;
    public getUserGroupMap(userGroupMapId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmartDineResponseUserGroupMapEntity>>;
    public getUserGroupMap(userGroupMapId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmartDineResponseUserGroupMapEntity>>;
    public getUserGroupMap(userGroupMapId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (userGroupMapId === null || userGroupMapId === undefined) {
            throw new Error('Required parameter userGroupMapId was null or undefined when calling getUserGroupMap.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SmartDineResponseUserGroupMapEntity>('get',`${this.basePath}/api/admin/usergroupmaps/${encodeURIComponent(String(userGroupMapId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getUserUserGroupMapMaps(observe?: 'body', reportProgress?: boolean): Observable<SmartDineResponseUserGroupMapEntity>;
    public getUserUserGroupMapMaps(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmartDineResponseUserGroupMapEntity>>;
    public getUserUserGroupMapMaps(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmartDineResponseUserGroupMapEntity>>;
    public getUserUserGroupMapMaps(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SmartDineResponseUserGroupMapEntity>('get',`${this.basePath}/api/admin/usergroupmaps`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param userGroupMapId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateUserGroupMap(body: UserGroupMapEntity, userGroupMapId: string, observe?: 'body', reportProgress?: boolean): Observable<SmartDineResponseUserGroupMapEntity>;
    public updateUserGroupMap(body: UserGroupMapEntity, userGroupMapId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmartDineResponseUserGroupMapEntity>>;
    public updateUserGroupMap(body: UserGroupMapEntity, userGroupMapId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmartDineResponseUserGroupMapEntity>>;
    public updateUserGroupMap(body: UserGroupMapEntity, userGroupMapId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updateUserGroupMap.');
        }

        if (userGroupMapId === null || userGroupMapId === undefined) {
            throw new Error('Required parameter userGroupMapId was null or undefined when calling updateUserGroupMap.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<SmartDineResponseUserGroupMapEntity>('put',`${this.basePath}/api/admin/usergroupmaps/${encodeURIComponent(String(userGroupMapId))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
